"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Salesman = void 0;
const GetSalesmanList_1 = require("./GetSalesmanList");
const GetSalesmanDetails_1 = require("./GetSalesmanDetails");
const GetSalesmanClients_1 = require("./GetSalesmanClients");
const GetSalesmanSupplies_1 = require("./GetSalesmanSupplies");
const PostSalesmanAdd_1 = require("./PostSalesmanAdd");
const PostSalesmanChangePassword_1 = require("./PostSalesmanChangePassword");
const PostSalesmanEdit_1 = require("./PostSalesmanEdit");
__exportStar(require("./GetSalesmanList"), exports);
__exportStar(require("./GetSalesmanDetails"), exports);
__exportStar(require("./GetSalesmanClients"), exports);
__exportStar(require("./GetSalesmanSupplies"), exports);
__exportStar(require("./PostSalesmanAdd"), exports);
__exportStar(require("./PostSalesmanChangePassword"), exports);
__exportStar(require("./PostSalesmanEdit"), exports);
exports.Salesman = {
    GetSalesmanList: GetSalesmanList_1.GetSalesmanList,
    GetSalesmanDetails: GetSalesmanDetails_1.GetSalesmanDetails,
    GetSalesmanClients: GetSalesmanClients_1.GetSalesmanClients,
    GetSalesmanSupplies: GetSalesmanSupplies_1.GetSalesmanSupplies,
    PostSalesmanAdd: PostSalesmanAdd_1.PostSalesmanAdd,
    PostSalesmanChangePassword: PostSalesmanChangePassword_1.PostSalesmanChangePassword,
    PostSalesmanEdit: PostSalesmanEdit_1.PostSalesmanEdit
};
//# sourceMappingURL=index.js.map